const attributes = {
  clientId: {
    type: "string",
  },
  uniqueId: {
    type: "string",
  },
  source: {
    type: "string",
  },
  poster: {
    type: "string",
  },
  isCDURL: {
    type: "boolean",
    default: false,
  },
  CDURL: {
    type: "string",
  },
  posterTime: {
    type: "number",
    default: 20,
  },
  provider: {
    type: "string",
    default: "library",
  },
  chapters: {
    type: "array",
    default: [],
  },
  controls: {
    type: "object",
    default: {
      ["play-large"]: true,
      restart: false,
      rewind: true,
      play: true,
      ["fast-forward"]: true,
      progress: true,
      ["current-time"]: true,
      duration: false,
      mute: true,
      volume: true,
      pip: false,
      airplay: false,
      settings: true,
      downlaod: false,
      fullscreen: true,
    },
  },
  brandColor: {
    type: "string",
    default: "#00B3FF",
  },
  width: {
    type: "object",
    default: {
      number: 100,
      unit: "%",
    },
  },
  radius: {
    type: "object",
    default: {
      number: 0,
      unit: "px",
    },
  },
  repeat: {
    type: "boolean",
    default: false,
  },
  autoplay: {
    type: "boolean",
    default: false,
  },
  muted: {
    type: "boolean",
    default: false,
  },
  sticky: {
    type: "boolean",
    default: false,
  },
  stickyPosition: {
    type: "string",
    default: "top-right",
  },
  popup: {
    type: "boolean",
    default: false,
  },
  popupType: {
    type: "string",
    default: "poster",
  },
  popupBtnStyle: {
    type: "object",
    default: {
      color: "#fff",
      backgroundColor: "#006BA1",
      fontSize: "16px",
      padding: "0.4em 1.2em",
    },
  },
  popupBtnText: {
    type: "string",
    default: "Watch Video",
  },
  popupBtnExists: {
    type: "boolean",
  },
  popupBtnClass: {
    type: "string",
  },
  disablePause: {
    type: "boolean",
    default: false,
  },
  thumbInPause: {
    type: "boolean",
    default: false,
  },
  thumbStyle: {
    type: "string",
    default: "default",
  },
  resetOnEnd: {
    type: "boolean",
    default: false,
  },
  autoHideControl: {
    type: "boolean",
    default: true,
  },
  protected: {
    type: "boolean",
    default: false,
  },
  password: {
    type: "string",
  },
  protectedText: {
    type: "string",
    default: "Please enter password to wath the video",
  },
  seekTime: {
    type: "number",
    default: 10,
  },
  startTime: {
    type: "number",
    default: 0,
  },
  preload: {
    type: "string",
    default: "metadata",
  },
  overlay: {
    type: "boolean",
    default: false,
  },
  overlayType: {
    type: "object",
  },
  overlayText: {
    type: "string",
  },
  overlayLogo: {
    type: "string",
  },
  overlayLink: {
    type: "string",
  },
  overlayTextColor: {
    type: "string",
    default: "#ffffff",
  },
  overlayFontSize: {
    type: "object",
    default: {
      number: 20,
      unit: "px",
    },
  },
  overlayTextHoverColor: {
    type: "string",
    default: "#ffffff",
  },
  ODFFT: {
    type: "string",
    default: "top",
  },
  ODFF: {
    type: "object",
    default: {
      number: 10,
      unit: "px",
    },
  },
  ODFST: {
    type: "string",
    default: "left",
  },
  ODFS: {
    type: "object",
    default: {
      number: 10,
      unit: "px",
    },
  },
  endscreen: {
    type: "boolean",
    default: false,
  },
  endscreenText: {
    type: "string",
    default: "Endscreen text",
  },
  endscreenTextLink: {
    type: "string",
    default: "#",
  },
  streaming: {
    type: "boolean",
    default: false,
  },
  streamingType: {
    type: "string",
    default: "hls",
  },
  quality: {
    type: "array",
    default: [
      {
        size: "size",
        video_file: "",
      },
    ],
  },
  subtitle: {
    type: "array",
    default: [
      {
        label: "label",
        caption_file: "",
      },
    ],
  },
  speed: {
    type: "object",
    default: {
      ["0.5"]: true,
      ["0.75"]: true,
      ["1"]: true,
      ["1.25"]: true,
      ["1.5"]: true,
      ["1.75"]: true,
      ["2"]: true,
      ["2.5"]: true,
      ["3"]: true,
    },
  },
  watermark: {
    type: "object",
    default: {
      enabled: false,
      type: "email",
      text: "",
    },
  },
  hideYoutubeUI: {
    type: "boolean",
    default: false,
  },
  captionEnabled: {
    type: "boolean",
    default: false,
  },
  additionalCSS: {
    type: "string",
  },
  additionalID: {
    type: "string",
  },
  vastTag: {
    type: "string",
  },
  saveState: {
    type: 'boolean',
    default: true
  }
};

export default attributes;

